<form #form="ngForm">
    <ng-container *ngIf="benefit">
        <div class="app-grid">
            <mat-form-field *ngIf="benefitCategories?.length" class="columns-4 small-columns-12">
                <mat-label appRemoveAriaOwns>Category</mat-label>
                <mat-select
                    required
                    #benefitCategory="ngModel"
                    name="benefitCategory"
                    [(ngModel)]="benefit.benefitCategory"
                    [compareWith]="isSameModel"
                >
                    <mat-option *ngFor="let category of benefitCategories" [value]="category">{{
                        category.name
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="benefitCategory.invalid">{{ benefitCategory.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="benefitProviders?.length" class="columns-4 small-columns-12">
                <mat-label appRemoveAriaOwns>Provider</mat-label>
                <mat-select #providerId="ngModel" name="providerId" [(ngModel)]="benefit.providerId">
                    <mat-option [value]="null">Plan Provider</mat-option>
                    <mat-option *ngFor="let provider of benefitProviders" [value]="provider.id">{{
                        provider.name
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="providerId.invalid">{{ providerId | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-8 small-columns-12">
                <mat-label>Description</mat-label>
                <textarea
                    name="description"
                    matInput
                    #name="ngModel"
                    rows="3"
                    [(ngModel)]="benefit.description"
                    placeholder="e.g. Employee Benefits"
                ></textarea>
                <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        @if (hasBenefitsPayroll) {
            <div class="margin-bottom-2">
                <app-segment-header
                    [title]="'benefits.benefitsPayroll.defineCompanyAndEmployeePremiumSplit'"
                ></app-segment-header>

                <p>{{ 'benefits.benefitsPayroll.selectTheCompanyContributionForThisBenefitPremium' | translate }}</p>

                <mat-radio-group
                    name="premiumSplit"
                    class="vertical"
                    [(ngModel)]="premiumSplit"
                    (ngModelChange)="updateSplitPercentage($event)"
                >
                    <mat-radio-button [value]="'companyFull'" class="margin-bottom-1">{{
                        'benefits.benefitsPayroll.companyCovers100OfPremium' | translate
                    }}</mat-radio-button>
                    <mat-radio-button [value]="'employeeFull'" class="margin-bottom-1">{{
                        'benefits.benefitsPayroll.employeeCovers100OfPremium' | translate
                    }}</mat-radio-button>
                    <mat-radio-button [value]="'custom'" class="margin-bottom-1">{{
                        'benefits.benefitsPayroll.companyWillCoverThePremiumAsACertainPercentage' | translate
                    }}</mat-radio-button>
                </mat-radio-group>

                @if (premiumSplit === 'custom') {
                    <mat-form-field>
                        <mat-label>
                            {{ 'benefits.benefitsPayroll.companyContribution' | translate }}
                        </mat-label>
                        <input
                            matInput
                            type="number"
                            [min]="1"
                            [max]="100"
                            pattern="[0-9]+"
                            required
                            name="splitPercentage"
                            [(ngModel)]="benefit.splitPercentage"
                            #premiumSplitPercentage="ngModel"
                        />
                        <span matSuffix>%</span>

                        <mat-error *ngIf="premiumSplitPercentage.invalid">
                            {{ premiumSplitPercentage.errors | formErrors }}
                        </mat-error>
                    </mat-form-field>
                }
            </div>
        }

        <div>
            <app-segment-header title="Optional Settings" [collapsible]="true" [collapsed]="true"></app-segment-header>
            <div class="content">
                <div class="app-grid">
                    <mat-form-field class="columns-4 small-columns-12">
                        <mat-label>Policy Number</mat-label>
                        <input
                            matInput
                            type="text"
                            #policyNumber="ngModel"
                            placeholder="e.g. PLC-001"
                            name="policyNumber"
                            [(ngModel)]="benefit.policyNumber"
                        />
                        <mat-error *ngIf="policyNumber.invalid">{{ policyNumber.errors | formErrors }}</mat-error>
                    </mat-form-field>

                    <mat-form-field class="columns-4 small-columns-12">
                        <mat-label>Benefit Booklet</mat-label>
                        <ui-mat-file-upload
                            #file="ngModel"
                            [ngModel]="benefit.file"
                            (fileSelected)="saveBooklet($event)"
                            placeholder="Upload a booklet..."
                            [allowedTypes]="['.pdf']"
                            name="booklet"
                        ></ui-mat-file-upload>
                        <ui-button type="outline">Browse</ui-button>
                        <mat-error *ngIf="file.invalid">{{ file.errors | formErrors }}</mat-error>
                    </mat-form-field>
                </div>

                <div class="app-grid">
                    <mat-form-field class="columns-4 small-columns-12">
                        <mat-label>Date this change occurred</mat-label>
                        <input
                            name="startAt"
                            #startAt="ngModel"
                            [(ngModel)]="benefit.startAt"
                            [matDatepicker]="effectiveAtDatePicker"
                            matInput
                        />
                        <mat-datepicker-toggle matSuffix [for]="effectiveAtDatePicker">
                            <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #effectiveAtDatePicker></mat-datepicker>
                        <mat-error *ngIf="startAt.invalid">{{ startAt.errors | formErrors }}</mat-error>
                    </mat-form-field>

                    <mat-form-field class="columns-4 small-columns-12">
                        <mat-label>Expires At</mat-label>
                        <input
                            name="expireAt"
                            #expireAt="ngModel"
                            [(ngModel)]="benefit.expireAt"
                            [matDatepicker]="expireAtDatePicker"
                            matInput
                        />
                        <mat-datepicker-toggle matSuffix [for]="expireAtDatePicker">
                            <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #expireAtDatePicker></mat-datepicker>
                        <mat-error *ngIf="expireAt.invalid">{{ expireAt.errors | formErrors }}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </ng-container>
</form>
